import React from 'react';
import { FlexBetween } from '../../../layout/FlexBetween/FlexBetween';
import { Loader } from '../../../shared/Loader/Loader';
import { TextCustom } from '../../../ui/TextCustom';
import { CustomNodeLeftInfo } from './CustomNodeLeftInfo';
import IconComponent from '../../../shared/IconComponents/IconComponent';

interface ICustomNodeItem {
    iconName: string;
    label: string;
    loading: boolean;
    text?: string;
    hasEndIcon?: boolean;
    endIconName?: string;
}

export const CustomNodeItem: React.FC<ICustomNodeItem> = ({ iconName, label, loading, text = '', hasEndIcon = false, endIconName = '' }) => {
    return (
        <FlexBetween>
            <CustomNodeLeftInfo iconName={iconName} label={label} />
            {loading ? (
                <Loader hasText={false} width={15} height={15} color="grey-dark" label={''} />
            ) : hasEndIcon ? (
                <IconComponent size={1.6} iconName={endIconName} />
            ) : (
                <TextCustom color="dark">{text}</TextCustom>
            )}
        </FlexBetween>
    );
};
